/*
  ELSKED micro-store — progressive enhancement only.
  Loaded solely by layout/elsked.liquid. Adds `.is-scrolled` to the header once
  the page is scrolled past a small threshold, which shrinks the logo (via CSS
  transform — no layout change, so content never jumps). Works without JS: the
  header simply stays at full size.
*/
(function () {
  var header = document.querySelector('.elsked-header');
  if (!header) return;

  var THRESHOLD = 60;
  var ticking = false;

  function update() {
    header.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
